import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import ObituaryItem from './ObituaryItem'
import { obituaryStore } from '../store/root'
import Notice from '../../components/common/ui/Notice'
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid'

export default function ObituaryList({ props }) {

    const {
        obituaryGalleryList,
        obituaryGalleryFetchAllLoading,
        obituaryGalleryFetchAllError
    } = useSelector(state => state.obituaryGalleryReducer)

    const [query, setQuery] = useState()

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obituaryStore.obituaryGallery.services.findAll({ page: 1, per_page: props.limit }))
    }, [])

    const showSearch = props.showSearch === "true" ? true : !!props.searchRedirectUrl
    const viewAllUrl = props.searchRedirectUrl || obituaryGalleryList?.return_to_obituaries_url
    const handleSearch = (e) => {
        e.preventDefault()
        window.location.href = viewAllUrl + '?q=' + query
    }

    return (
        <>
            {!obituaryGalleryFetchAllLoading ? (
                <>
                    {obituaryGalleryFetchAllError ? (
                        <Notice type="notice" description="Invalid Configuration. Please contact your administrator." />
                    ) : (
                        <>
                            {obituaryGalleryList?.data?.length ? (
                                <>
                                    {showSearch && (
                                        <div className='search-form-container flex flex-col items-center mb-10'>
                                            <h3 className='search-title text-2xl mb-3'>Search Obituaries</h3>
                                            <div className="w-full relative flex items-center">
                                                <form className="search-form w-full" onSubmit={handleSearch}>
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        id="search"
                                                        defaultValue={query}
                                                        placeholder={"Search Obituaries"}
                                                        onChange={(e) => setQuery(e.target.value)}
                                                        className="search-input shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full pr-12 sm:text-md border-gray-300 rounded-md"
                                                    />
                                                    <div className="absolute inset-y-0 right-0 flex py-2.5 pr-2.5">
                                                        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
                                                    </div>
                                                    <button className='hidden' type="submit">Search</button>
                                                </form>
                                            </div>
                                        </div>
                                    )}
                                    <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 mb-4 obituary-list-container">
                                        {obituaryGalleryList?.data?.map((obituary, i) => (
                                            <ObituaryItem obituary={obituary} photoShape={props.photoShape} showFlowersButton={props.showFlowersButton} showFlowersIcon={props.showFlowersIcon} target={props.target} key={i} />
                                        ))}
                                    </ul>
                                    {props.showViewAllButton === "true" && (
                                        <div className="w-full flex justify-center obituary-view-all-container">
                                            <a href={viewAllUrl} target={"_blank"} rel="noreferrer" className="obituary-view-all-link">
                                                <button className="w-72 px-4 py-2 border rounded-md border-blue-600 text-blue-600 obituary-view-all-button">View All Obituaries</button>
                                            </a>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>No obituaries found</>
                            )}
                        </>
                    )}
                </>
            ) : (
                <Skeleton height={25} count={3} />
            )}
        </>
    )
}
